import { action } from 'satcheljs';

export const setActionConfirmationsEnabled = action(
    'SET_ACTION_CONFIRMATIONS_ENABLED',
    (isEnabled: boolean) => ({
        isEnabled,
    })
);

export const discardActionConfirmationsOption = action('DISCARD_ACTION_CONFIRMATIONS_OPTION');
